import { render } from "./Lucky6.vue?vue&type=template&id=cac48fb0&scoped=true"
import script from "./Lucky6.vue?vue&type=script&lang=js"
export * from "./Lucky6.vue?vue&type=script&lang=js"

import "./Lucky6.vue?vue&type=style&index=0&id=cac48fb0&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac48fb0"]])

export default __exports__